import { ClassroomBooking } from "@models/ISchema";
import { Preferences } from "../context/types";

/**
 * Build the search `preferences` derived from a given booking, keeping any
 * existing preference fields untouched (single source of truth for how a
 * booking maps to `preferences.building` / `preferences.program`).
 *
 * @param booking the booking to derive building/program from
 * @param base the current preferences to spread over
 *
 * @return Preferences
 */
export const buildBookingPreferences = (
  booking: ClassroomBooking,
  base: Preferences,
): Preferences => {
  const building = booking?.classroom?.building;

  return {
    ...base,
    building: building?.id ? { value: building?.id, label: building?.name, ...building } : null,
    program: booking?.relatedProgram ?? null,
  };
};
